import { useState, MouseEvent, ReactNode } from 'react'
import { Button, ButtonTypeMap, Menu, useMediaQuery, useTheme } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import MoreVertIcon from '@mui/icons-material/MoreVert'
interface ButtonDesplegableProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string
  color?: ButtonTypeMap['props']['color']
  variant?: ButtonTypeMap['props']['variant']
  isLoading?: boolean
  children: ReactNode
  fullWidth?: boolean
}
const ButtonDesplegable = ({
  label,
  color = 'primary',
  variant = 'contained',
  isLoading,
  className,
  children,
  fullWidth
}: ButtonDesplegableProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div style={{ ...(isMobile && { marginBottom: 'auto' }) }}>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant={variant}
        color={color}
        disabled={isLoading}
        fullWidth={fullWidth}
        endIcon={label ? isLoading ? false : anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon /> : false}
      >
        {label ? isLoading ? 'Wait' : label : <MoreVertIcon />}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClick={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          ...(fullWidth && {
            style: {
              width: anchorEl?.offsetWidth
            }
          })
        }}
        className={className}
      >
        {children}
      </Menu>
    </div>
  )
}
export default ButtonDesplegable
